import React, { useEffect, useState } from 'react';
import axios from 'axios';

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

export default function TerminalManagement() {
  const [terminals, setTerminals] = useState([]);
  const [sites, setSites] = useState([]);
  const [form, setForm] = useState({ name: '', terminalCode: '', siteId: '' });
  const [newToken, setNewToken] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const load = async () => {
    try {
      const [t, s] = await Promise.all([
        axios.get('/api/terminals', { headers: auth() }),
        axios.get('/api/attendance/sites/all', { headers: auth() })
      ]);
      setTerminals(t.data || []);
      setSites(s.data || []);
      setError('');
    } catch (e) {
      setError(e.response?.data?.message || 'No fue posible cargar las terminales.');
    }
  };

  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setMessage(''); setError(''); setNewToken('');
    try {
      const r = await axios.post('/api/terminals', { ...form, siteId: Number(form.siteId) }, { headers: auth() });
      setNewToken(r.data.terminal.token);
      setMessage(r.data.message);
      setForm({ name: '', terminalCode: '', siteId: '' });
      await load();
    } catch (err) {
      setError(err.response?.data?.message || 'No fue posible crear la terminal.');
    }
  };

  const toggle = async (id, active) => {
    try {
      await axios.put(`/api/terminals/${id}/active`, { active: !active }, { headers: auth() });
      await load();
    } catch (e) { setError(e.response?.data?.message || 'No fue posible cambiar el estado.'); }
  };

  return (
    <div style={{ maxWidth: 1000, margin: '40px auto', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <h1>Terminales biométricas</h1>
      <p style={{ color: '#68727d' }}>Crea y administra los kioscos físicos de la empresa. El token se muestra una sola vez.</p>
      <form onSubmit={create} style={{ display: 'grid', gap: 12, gridTemplateColumns: '2fr 1fr 2fr', alignItems: 'end', margin: '24px 0' }}>
        <label>Nombre<input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={input} placeholder="Entrada principal" /></label>
        <label>Código<input required value={form.terminalCode} onChange={e => setForm({ ...form, terminalCode: e.target.value })} style={input} placeholder="TER-01" /></label>
        <label>Sitio<select required value={form.siteId} onChange={e => setForm({ ...form, siteId: e.target.value })} style={input}><option value="">Selecciona…</option>{sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</select></label>
        <button type="submit" style={button}>Crear terminal</button>
      </form>
      {message && <div style={ok}>{message}</div>}
      {newToken && <div style={tokenBox}><strong>Token de configuración</strong><code>{newToken}</code><small>Guárdalo. Después configura el navegador de la terminal entrando a /terminal.</small></div>}
      {error && <div style={errorBox}>{error}</div>}
      <div style={{ display: 'grid', gap: 12, marginTop: 24 }}>
        {terminals.map(t => <div key={t.id} style={row}><div><strong>{t.name}</strong><div style={muted}>{t.terminalCode} · {t.site?.name || `Sitio ${t.siteId}`}</div></div><button onClick={() => toggle(t.id, t.active)} style={secondary}>{t.active ? 'Desactivar' : 'Activar'}</button></div>)}
      </div>
    </div>
  );
}

const input = { display: 'block', width: '100%', boxSizing: 'border-box', marginTop: 6, padding: 11, borderRadius: 9, border: '1px solid #cbd2d9' };
const button = { border: 0, borderRadius: 9, padding: 12, background: '#111827', color: '#fff', fontWeight: 700, cursor: 'pointer' };
const secondary = { border: '1px solid #cbd2d9', borderRadius: 9, padding: '9px 14px', background: '#fff', cursor: 'pointer' };
const row = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 16, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12 };
const muted = { color: '#68727d', marginTop: 4, fontSize: 14 };
const ok = { padding: 12, background: '#ecfdf5', borderRadius: 9, marginBottom: 12 };
const errorBox = { padding: 12, background: '#fff1f2', color: '#9f1239', borderRadius: 9 };
const tokenBox = { padding: 16, background: '#f3f4f6', borderRadius: 10, display: 'grid', gap: 8, marginBottom: 12 };
